import React from 'react';
import { useMsal } from '@azure/msal-react';
import styles from './LoginPage.module.scss';
import { LOGIN_SCOPES } from '../auth/msalConfig';

function LoginPage() {
  const { instance } = useMsal();

  const handleLogin = () => {
    // Includes the API scope so acquireTokenSilent can mint access tokens later.
    instance.loginRedirect({
      scopes: LOGIN_SCOPES
    });
  };

  return (
    <div className={styles.container}>
      <header className="header">
        <div className="wrapper">
          <div className="logo">
            <img src="/images/2025/1095 - Circle of Excellence_Colored_White_300x72.png" alt="Circle of Excellence" />
          </div>
        </div>
      </header>
      
      <section className={`intro ${styles.content}`}>
        <div className="wrapper">
          <h1 className={styles.title}>
            Employee Portal
          </h1>
          <p className={styles.subtitle}>
            Sign in with your Infor network credentials to access Circle of Excellence documents
          </p>
          
          <div className={styles.buttonContainer}>
            <button onClick={handleLogin} className="cta">
              <span>Sign In with Microsoft</span> →
            </button>
          </div>
        </div>
      </section>

      <footer className="site-footer">
        <div className="wrapper">
          <div className="legal">&copy; {new Date().getFullYear()} Infor. All rights reserved.</div>
          <div className="brand">Designed and built by Infor Marketing</div>
        </div>
      </footer>
    </div>
  );
}

export default LoginPage;